<div class="bl-border-radius customborder">
  <label
    class="bl-label bl-display--flex bl-align-items--center bl-font-color--black bl-font-weight--600 bl-font-size--14 bl-display--flex bl-padding--16"
  >
    <div class="bl-display--flex bl-flex--auto">{{ field.label }}</div>
    <div class="bl-toggle-switch condensed" [ngClass]="{ active: value }">
      <button
        type="button"
        [class.bl-disabled]="!field.enabled"
        [disabled]="!field.enabled"
        [id]="field.id"
        [attr.data-automation-id]="field.automationId"
        (click)="toggle()"
      ></button>
    </div>
    <span class="bl-margin-left--8 bl-font-size--16"> {{ !value ? 'No' : 'Yes' }}</span>
  </label>
</div>
